import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoginService } from './login.service';

export const loginInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  
  console.log("loginInterceptor(): " + "Start");

  const auth = inject(LoginService);
  const header = auth.getAuthHeader();


  if (header && !req.headers.has('Authorization')) {
    const cloned = req.clone({ setHeaders: { Authorization: header } });
    return next(cloned);
  }

  return next(req);
};